// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6a5219e2","453":"c8be8448","455":"17150112"}[chunkId] + ".chunk.js";
};